import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataService} from '../services/dataService';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {CordovaUIService, Rouleau, RouleauNote} from '../../common';
import {NoteCategoryUITab, PageEnum, RouleauUI, TypeSolEnum, UtilisationEnum} from '../entity';

@Component({
    selector   : 'app-comparison',
    templateUrl: './comparison.component.html',
    styleUrls  : ['./comparison.component.scss']
})
export class ComparisonComponent implements OnInit, OnDestroy {
    /**
     * All Rouleaux
     */
    private allRouleaux: Array<RouleauUI> = [];
    /**
     * Filtered Rouleaux
     */
    private _filteredRouleaux: Array<RouleauUI> = [];
    /**
     * Not Filtered Rouleaux
     */
    private _notFilteredRouleaux: Array<RouleauUI> = [];
    /**
     * Is the filter by the Sol
     */
    private _isFilterBySol: boolean = true;
    /**
     * Is Edit
     */
    private _isEdit: boolean = false;
    /**
     * Is Ready To show
     */
    private _isReadyToShow: boolean = false;
    /**
     * Rouleau Selected
     */
    private _selectedRouleau: RouleauUI = null;
    /**
     * Edit Index
     */
    private editIndex: number = -1;
    /**
     * Ui for the tab.
     */
    private _viewSolTab: Array<NoteCategoryUITab> = [
        {
            category: TypeSolEnum.SOL_LOURD,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.RAPPUYAGE_LIGNE,
                    key        : 'solLourdRappuyageLigne'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.INSENSIBLE_COLLAGE,
                    key        : 'solLourdInsCollage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.INSENSIBLE_PIERRE,
                    key        : 'solLourdInsPierres'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.NIVELLEMENT,
                    key        : 'solLourdNivellement'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.PROFONDEUR,
                    key        : 'solLourdCtrlProf'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.RAPPUYAGE,
                    key        : 'solLourdRappuyage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.ROULAGE,
                    key        : 'solLourdRoulage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.EMIETTEMENT,
                    key        : 'solLourdEmiettement'
                },
            ]
        },
        {
            category: TypeSolEnum.SOL_MOYEN,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.RAPPUYAGE_LIGNE,
                    key        : 'solMoyenRappuyageLigne'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.INSENSIBLE_COLLAGE,
                    key        : 'solMoyenInsCollage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.INSENSIBLE_PIERRE,
                    key        : 'solMoyenInsPierres'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.NIVELLEMENT,
                    key        : 'solMoyenNivellement'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.PROFONDEUR,
                    key        : 'solMoyenCtrlProf'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.RAPPUYAGE,
                    key        : 'solMoyenRappuyage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.ROULAGE,
                    key        : 'solMoyenRoulage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.EMIETTEMENT,
                    key        : 'solMoyenEmiettement'
                },
            ]
        },
        {
            category: TypeSolEnum.SOL_LEGER,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.RAPPUYAGE_LIGNE,
                    key        : 'solLegerRappuyageLigne'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.INSENSIBLE_COLLAGE,
                    key        : 'solLegerInsCollage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.INSENSIBLE_PIERRE,
                    key        : 'solLegerInsPierres'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.NIVELLEMENT,
                    key        : 'solLegerNivellement'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.PROFONDEUR,
                    key        : 'solLegerCtrlProf'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.RAPPUYAGE,
                    key        : 'solLegerRappuyage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.ROULAGE,
                    key        : 'solLegerRoulage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.EMIETTEMENT,
                    key        : 'solLegerEmiettement'
                },
            ]
        },
        {
            category: TypeSolEnum.MOYENNE,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.RAPPUYAGE_LIGNE,
                    key        : 'generalRappuyageLigne'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.INSENSIBLE_COLLAGE,
                    key        : 'generalInsCollage'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.INSENSIBLE_PIERRE,
                    key        : 'generalInsPierres'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.NIVELLEMENT,
                    key        : 'generalNivellement'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.PROFONDEUR,
                    key        : 'generalCtrlProf'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.RAPPUYAGE,
                    key        : 'generalRappuyage'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.ROULAGE,
                    key        : 'generalRoulage'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.EMIETTEMENT,
                    key        : 'generalEmiettement'
                },
            ]
        }
    ];

    /**
     * Ui for the tab.
     */
    private _viewUtilisationTab: Array<NoteCategoryUITab> = [
        {
            category: UtilisationEnum.RAPPUYAGE_LIGNE,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.RAPPUYAGE_LIGNE,
                    key        : 'solLourdRappuyageLigne'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.RAPPUYAGE_LIGNE,
                    key        : 'solMoyenRappuyageLigne'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.RAPPUYAGE_LIGNE,
                    key        : 'solLegerRappuyageLigne'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.RAPPUYAGE_LIGNE,
                    key        : 'generalRappuyageLigne'
                },
            ]
        },
        {
            category: UtilisationEnum.INSENSIBLE_COLLAGE,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.INSENSIBLE_COLLAGE,
                    key        : 'solLourdInsCollage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.INSENSIBLE_COLLAGE,
                    key        : 'solMoyenInsCollage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.INSENSIBLE_COLLAGE,
                    key        : 'solLegerInsCollage'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.INSENSIBLE_COLLAGE,
                    key        : 'generalInsCollage'
                },
            ]
        },
        {
            category: UtilisationEnum.INSENSIBLE_PIERRE,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.INSENSIBLE_PIERRE,
                    key        : 'solLourdInsPierres'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.INSENSIBLE_PIERRE,
                    key        : 'solMoyenInsPierres'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.INSENSIBLE_PIERRE,
                    key        : 'solLegerInsPierres'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.INSENSIBLE_PIERRE,
                    key        : 'generalInsPierres'
                },
            ]
        },
        {
            category: UtilisationEnum.NIVELLEMENT,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.NIVELLEMENT,
                    key        : 'solLourdNivellement'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.NIVELLEMENT,
                    key        : 'solMoyenNivellement'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.NIVELLEMENT,
                    key        : 'solLegerNivellement'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.NIVELLEMENT,
                    key        : 'generalNivellement'
                },
            ]
        },
        {
            category: UtilisationEnum.PROFONDEUR,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.PROFONDEUR,
                    key        : 'solLourdCtrlProf'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.PROFONDEUR,
                    key        : 'solMoyenCtrlProf'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.PROFONDEUR,
                    key        : 'solLegerCtrlProf'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.PROFONDEUR,
                    key        : 'generalCtrlProf'
                },
            ]
        },
        {
            category: UtilisationEnum.RAPPUYAGE,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.RAPPUYAGE,
                    key        : 'solLourdRappuyage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.RAPPUYAGE,
                    key        : 'solMoyenRappuyage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.RAPPUYAGE,
                    key        : 'solLegerRappuyage'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.RAPPUYAGE,
                    key        : 'generalRappuyage'
                },
            ]
        },
        {
            category: UtilisationEnum.ROULAGE,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.ROULAGE,
                    key        : 'solLourdRoulage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.ROULAGE,
                    key        : 'solMoyenRoulage'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.ROULAGE,
                    key        : 'solLegerRoulage'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.ROULAGE,
                    key        : 'generalRoulage'
                },
            ]
        },
        {
            category: UtilisationEnum.EMIETTEMENT,
            selected: true,
            tab     : [
                {
                    typeSol    : TypeSolEnum.SOL_LOURD,
                    utilisation: UtilisationEnum.EMIETTEMENT,
                    key        : 'solLourdEmiettement'
                },
                {
                    typeSol    : TypeSolEnum.SOL_MOYEN,
                    utilisation: UtilisationEnum.EMIETTEMENT,
                    key        : 'solMoyenEmiettement'
                },
                {
                    typeSol    : TypeSolEnum.SOL_LEGER,
                    utilisation: UtilisationEnum.EMIETTEMENT,
                    key        : 'solLegerEmiettement'
                },
                {
                    typeSol    : TypeSolEnum.MOYENNE,
                    utilisation: UtilisationEnum.EMIETTEMENT,
                    key        : 'generalEmiettement'
                },
            ]
        },
    ];

    /**
     * Constructor
     * @param translate
     * @param dataService
     * @param router
     * @param route
     * @param location
     * @param cordovaService
     */
    constructor(private translate: TranslateService,
                private dataService: DataService,
                private router: Router,
                private route: ActivatedRoute,
                private location: Location,
                private cordovaService: CordovaUIService) {
    }


    /**
     * NgOnInit
     */
    public ngOnInit() {
        console.log('OnInit ComparisonComponent');
        this.dataService.cleanNewPage();
        this.translate.get('comparisonPage.pageTitle').subscribe(
            (res: string) => {
                this.dataService.publishNewPageTitle(PageEnum.COMPARISON, res);
            }
        );
        const promiseR = this.dataService.getRouleauxUI();

        promiseR.then(
            (res) => {
                this.allRouleaux = res;
            },
            () => {
                // TODO Afficher une erreur
            }
        );
        Promise.all([promiseR])
            .then(
                () => {
                    this.initComparison();
                },
                () => {
                    // Cas d'erreur
                    this.initComparison();
                }
            );
    }

    /**
     * NgOnDestroy
     */
    public ngOnDestroy() {
        console.log('OnDestroy ComparisonComponent');
    }

    /**
     * Init the filter.
     */
    private initComparison() {
        this._filteredRouleaux = this.allRouleaux.filter(value => value.selected);
        this._notFilteredRouleaux = this.allRouleaux.filter(value => !value.selected);
        this._isReadyToShow = true;
    }

    /**
     * Remove the rouleau in the selection
     * @param rouleau rouleau to remove
     * @param idx index of the rouleau
     */
    public removeSelection(rouleau: RouleauUI, idx: number): void {
        rouleau.selected = false;
        this._filteredRouleaux.splice(idx, 1);

        this.dataService.removeSelection(rouleau.rouleau.code);
        this.computeSelection();
    }

    /**
     * Remove the rouleau in the selection
     */
    public addSelection(): void {
        this._selectedRouleau.selected = true;
        this._filteredRouleaux.push(this._selectedRouleau);

        this.dataService.addSelection(this._selectedRouleau.rouleau.code);
        this.computeSelection();
    }

    /**
     * Change the selection.
     */
    public changeSelection(): void {
        this._filteredRouleaux[this.editIndex].selected = false;
        this._selectedRouleau.selected = true;
        this._filteredRouleaux[this.editIndex] = this._selectedRouleau;

        this.dataService.addSelection(this._selectedRouleau.rouleau.code);
        this.computeSelection();
    }

    /**
     * Internalm Method to compute the not filtered rouleaux
     */
    private computeSelection(): void {
        this._notFilteredRouleaux = this.allRouleaux.filter(value => !value.selected);
        this._isEdit = false;
        this.editIndex = -1;
        this._selectedRouleau = null;
    }


    /**
     * Edit the selection by index
     * @param idx the index of the rouleau to edit
     */
    public editSelection(idx: number): void {
        this.editIndex = idx;
        this._isEdit = true;
    }

    /**
     * Getter the filtered rouleaux
     */
    public get filteredRouleaux(): Array<RouleauUI> {
        return this._filteredRouleaux;
    }

    /**
     * Getter.
     */
    public get viewSolTab(): Array<NoteCategoryUITab> {
        return this._viewSolTab;
    }

    /**
     * Getter.
     */
    public get viewUtilisationTab(): Array<NoteCategoryUITab> {
        return this._viewUtilisationTab;
    }

    /**
     * Getter.
     */
    public get isFilterBySol(): boolean {
        return this._isFilterBySol;
    }

    /**
     * Setter
     * @param value
     */
    public set isFilterBySol(value: boolean) {
        this._isFilterBySol = value;
    }

    /**
     * Get the not filtered rouleaux
     */
    public get notFilteredRouleaux(): Array<RouleauUI> {
        return this._notFilteredRouleaux;
    }

    /**
     * Is the edition mode.
     */
    public get isEdit(): boolean {
        return this._isEdit;
    }

    /**
     * Getter the selected rouleau
     */
    public get selectedRouleau(): RouleauUI {
        return this._selectedRouleau;
    }

    /**
     * Setter the selected rouleau
     * @param value
     */
    public set selectedRouleau(value: RouleauUI) {
        this._selectedRouleau = value;
    }

    /**
     * Getter of the indicator if ready to shwo the page
     */
    public get isReadyToShow(): boolean {
        return this._isReadyToShow;
    }

    /**
     * Get Rouleau Property
     * @param rouleau
     * @param prop
     */
    public getRouleauNoteProperty(rouleau: RouleauNote, prop: string): number {
        // @ts-ignore
        return rouleau[prop];
    }
}
